import spacing from '@/constants/spacing';
import {createThemedStyles} from '@/theme';

export const styles = createThemedStyles(() => ({
  container: {
    position: 'relative',
    overflow: 'hidden',
    height: 'auto',
  },
  content: {
    height: 'auto',
  },
  seeMoreContainer: {
    minHeight: spacing.m,
    justifyContent: 'flex-end',
  },
  gradient: {
    position: 'absolute',
    left: 0,
    right: 0,
  },
}));
